import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MessageDescriptorPropType } from '@quintoandar/cozy-core/proptypes/Intl';
import Box from '@quintoandar/cozy-core/Box';
import Button from '@quintoandar/cozy-core/Button';
import ModalDialog from '@quintoandar/cozy-core/Dialog/ModalDialog';
import DialogContent from '@quintoandar/cozy-core/DialogContent';
import DialogContentText from '@quintoandar/cozy-core/DialogContentText';
import DialogActions from '@quintoandar/cozy-core/DialogActions';
import Typography from '@quintoandar/cozy-core/Typography';
import CopyIcon from '@quintoandar/cozy-icons/Copy';
import { Link } from 'react-router';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { getBrandName } from '../../Base/i18n/brand';

export const ConfirmationDialog = ({
  open,
  onCancel,
  subHeading,
  confirmationTitle,
  confirmationDescription,
  confirmationButtonText,
  cancelButtonText,
  confirmationAction,
  isDialogLoading,
  link,
  linkTitle,
}) => (
  <ModalDialog
    maxWidth="xs"
    open={open}
    onClose={onCancel}
    title={confirmationTitle.defaultMessage}
  >
    <Box>
      {subHeading && (
        <Typography>
          <FormattedMessage {...subHeading} />
        </Typography>
      )}

      <FormattedMessage
        {...confirmationDescription}
        values={{ companyName: getBrandName() }}
      />

      {link && (
        <DialogContent>
          <DialogContentText color="black">
            <Typography>
              <FormattedMessage {...linkTitle} />
            </Typography>
          </DialogContentText>
          <DialogContentText>
            <Box display="flex">
              <Box mr={1}>
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  to={`https://${link}`}
                >
                  <Typography>{link}</Typography>
                </Link>
              </Box>
              <CopyToClipboard text={link}>
                <CopyIcon />
              </CopyToClipboard>
            </Box>
          </DialogContentText>
        </DialogContent>
      )}

      <DialogActions>
        {cancelButtonText && (
          <Button variant="quiet" onClick={onCancel} disabled={isDialogLoading}>
            <FormattedMessage {...cancelButtonText} />
          </Button>
        )}

        <Button onClick={confirmationAction} isLoading={isDialogLoading}>
          <FormattedMessage {...confirmationButtonText} />
        </Button>
      </DialogActions>
    </Box>
  </ModalDialog>
);

ConfirmationDialog.propTypes = {
  open: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  subHeading: PropTypes.string,
  confirmationTitle: MessageDescriptorPropType.isRequired,
  confirmationDescription: MessageDescriptorPropType.isRequired,
  confirmationButtonText: MessageDescriptorPropType.isRequired,
  cancelButtonText: MessageDescriptorPropType,
  confirmationAction: PropTypes.func.isRequired,
  isDialogLoading: PropTypes.bool.isRequired,
  link: MessageDescriptorPropType,
  linkTitle: MessageDescriptorPropType,
};

export default ConfirmationDialog;
